import { useTranslation } from 'react-i18next'

import CommentCartModal from '@features/cart/ui/comment/modal'
import styles from '@features/cart/ui/comment/modal/styles.module.scss'
import { useModalStore } from '@features/modal'

import { Product } from '@shared/generated'





export default function useCartComment () {
  const { openModal, closeModal } = useModalStore()
  const { t: tc } = useTranslation('cart')

  const openCartCommentModal = (product: Product) => {
    openModal('cartComment', <CommentCartModal data={product} />, {
      title: tc('product.comment'),

      classes: {
        content: styles['modal-content'],
      },
    })
  }

  const closeCartCommentModal = () => {
    closeModal('cartComment')
  }

  return {
    openCartCommentModal,
    closeCartCommentModal,
  }
}